import React from 'react';
import Stylesheet from './Manual.module.css';

const Manual = (props) => {

    return (
        <div className={Stylesheet.Container}>
            <h1>software manual page</h1>
        </div>
    )
}

export default Manual;